import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import PinkCalendarIcon from '~images/pink-calendar-icon.svg'
import { useIsMobile } from "~helpers/hooks/useIsMobile";

const FreePeriodScreenV2 = () => {
  const isMobile = useIsMobile();

  return (
    <Screen id='trial'>
      <Styled.Container>
        <Styled.Left>
          <Styled.Icon>
            <Styled.IconInfo>
              <Styled.IconDayCount>7</Styled.IconDayCount>
              <Styled.IconText>дней</Styled.IconText>
            </Styled.IconInfo>
          </Styled.Icon>
        </Styled.Left>
        <Styled.Right>
          <Styled.Title>
            Бесплатный период для <StyledScreen.GreenText>тестирования</StyledScreen.GreenText>
          </Styled.Title>
          {
            !isMobile &&
            <Styled.Text>
                У вас будет 7 дней, чтобы бесплатно протестировать настроенную АТС и оценить ее влияние на ваш бизнес. <br/><br/>
                Через 7 дней сможете оплатить лицензию с сохранением всех настроек.
            </Styled.Text>
          }
        </Styled.Right>
      </Styled.Container>
      {
        isMobile &&
        <Styled.Text>
            У вас будет 7 дней, чтобы бесплатно протестировать настроенную АТС и оценить ее влияние на ваш бизнес. <br/><br/>
            Через 7 дней сможете оплатить лицензию с сохранением всех настроек.
        </Styled.Text>
      }
    </Screen>
  )
}

export { FreePeriodScreenV2 }
